import { isColombia } from './../../../Contexts/Shared/utils/region-utils';
import { TDataArticlesJournalism, TDataCommentsLandlord, TDataSectionSecondary } from './LandingLandlord.styled';

const GetCountryTranslation = isColombia();

export const DataSectionSecondary: TDataSectionSecondary[] = [
  {
    id: '1',
    title: 'Encontramos a las personas indicadas para tu inmueble.',
    description: 'Basados en su historial crediticio, capacidad de ingreso y nuestro proceso de investigación.',
    borderColor: '#facd23',
    iconColor: '#ffbd11',
    messageButton: 'Encuentra el inquilino ideal',
    imageUrl: '/images/landings/landlord02.svg',
    imageUrlMobile: '/images/landing-pages/landing-landlord/landlord05.svg',
    widthImageMobile: 216,
    heightImageMobile: 114,
    widthImageDesktop: 375,
    heightImageDesktop: 272,
    altImage: 'publicar inmueble con Aptuno rápido y seguro',
  },
  {
    id: '2',
    title: 'No más cobranza. Garantizamos tu pago. Cada mes.',
    description: 'Garantizamos el pago puntual de tu arriendo. Si el inquilino no paga, nosotros pagamos.',
    borderColor: '#3CD278',
    iconColor: '#3CD278',
    messageButton: 'Garantiza tus pagos',
    imageUrl: '/images/landing-pages/landing-landlord/landlord03.svg',
    widthImageMobile: 160,
    heightImageMobile: 156,
    widthImageDesktop: 284,
    heightImageDesktop: 277,
    altImage: 'arrendar inmueble con Aptuno rápido y seguro',
  },
  {
    id: '3',
    title: 'Con exclusividad, llegas aún más lejos.',
    description: 'Publica exclusivamente con nosotros y gana un 10% de descuento en tu primer canon.',
    borderColor: GetCountryTranslation ? '#FF784B' : '#D250E6',
    iconColor: GetCountryTranslation ? '#FF784B' : '#D250E',
    messageButton: 'Hagámoslo oficial',
    imageUrl: '/images/landing-pages/landing-landlord/man-flag.svg',
    widthImageMobile: GetCountryTranslation ? 205 : 288,
    heightImageMobile: GetCountryTranslation ? 156 : 293,
    widthImageDesktop: 288,
    heightImageDesktop: GetCountryTranslation ? 219 : 293,
    altImage: 'quiero-publicar-inmueble',
  },
  {
    id: '4',
    title: 'Puedes adelantar tu renta!',
    description: 'Publica con nosotros y puedes recibir el pago de tu renta por adelantado.',
    borderColor: '#00E1EF',
    iconColor: '#00E1EF',
    messageButton: 'Anticipa tu renta',
    widthImageMobile: 160,
    heightImageMobile: 156,
    widthImageDesktop: 284,
    heightImageDesktop: 277,
    altImage: 'quiero-publicar-inmueble',
  },
];

export const getImageSrc = (dataEl: TDataSectionSecondary) =>
  dataEl.imageUrlMobile ? dataEl.imageUrlMobile : dataEl.imageUrl;

export const DataCommentsLandlord: TDataCommentsLandlord[] = [
  {
    namePerson: 'Mabel Moreno',
    comment: '"Fueron solo dos días y ya tenía el inmueble con un cliente. Los recomiendo muchísimo.”',
    star: 5,
    checked: true,
    altImage: 'arrendar inmueble rápido en solo dos días',
  },
  {
    namePerson: 'Maria Campos',
    comment: '“Muy buena plataforma, buena atención y mas si te encuentras fuera de Bogota”',
    star: 4,
    checked: false,
    altImage: 'Aptuno la mejor plataforma para arrendar',
  },
  {
    namePerson: 'Andrés Ferrero',
    comment: '“Con la plataforma podemos superar la barrera de burocracia que tanto nos ha dificultado arrendar.”',
    star: 5,
    checked: false,
    altImage: 'alquilar casa o departamento fácil y rápido',
  },
];

export const DataArticlesJournalism: TDataArticlesJournalism[] = GetCountryTranslation
  ? [
      {
        logoJournalism: '/images/landing-pages/landing-landlord/logos/logo_forbes.svg',
        articleContent: 'Aptuno, que está digitalizando los arriendos de vivienda, levanta US$5 millones.',
        articleUrl:
          'https://forbes.co/2021/11/30/emprendedores/aptuno-que-esta-digitalizando-los-arriendos-de-vivienda-obtiene-us5-millones/',
      },
      {
        logoJournalism: '/images/landing-pages/landing-landlord/logos/logo_republica.svg',
        articleContent: 'Proptech Aptuno, plataforma para arrendar viviendas, presentó sus nuevos productos.',
        articleUrl:
          'https://www.larepublica.co/empresas/proptech-aptuno-plataforma-para-arrendar-viviendas-presento-sus-nuevos-productos-3290134',
      },
      {
        logoJournalism: '/images/landing-pages/landing-landlord/logos/logo_portafolio.svg',
        articleContent: 'Aptuno: conozca qué ofrece esta nueva "proptech" colombiana de arriendos.',
        articleUrl:
          'https://www.portafolio.co/mis-finanzas/vivienda/aptuno-que-ofrece-esta-proptech-colombiana-de-arriendos-559261',
      },
    ]
  : [
      {
        logoJournalism: '/images/landing-pages/landing-landlord/logos/logo_reforma.svg',
        articleContent: 'Se fortalece arrendadora colombiana en el País.',
        articleUrl:
          'https://www.reforma.com/libre/acceso/accesofb.htm?urlredirect=/se-fortalece-arrendadora-colombiana-en-el-pais/ar2320155',
      },
      {
        logoJournalism: '/images/landing-pages/landing-landlord/logos/logo_inmobiliare.svg',
        articleContent: 'Aptuno recauda 5.1 mdd y lanza nuevos productos para vivienda en renta.',
        articleUrl: 'https://inmobiliare.com/aptuno-recauda-5-1-mdd-y-lanza-nuevos-productos-para-vivienda-en-renta/',
      },
      {
        logoJournalism: '/images/landing-pages/landing-landlord/logos/logo_economista.svg',
        articleContent: 'Aptuno levanta 5.1 millones de dólares y apunta hacia la conquista del mercado.',
        articleUrl:
          'https://www.eleconomista.com.mx/econohabitat/Aptuno-levanta-5.1-millones-de-dolares-y-apunta-hacia-la-conquista-del-mercado-de-vivienda-en-renta-en-AL--20211130-0154.html',
      },
    ];
